"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minWidthHuge = exports.minWidthLarge = exports.minWidthMedium = exports.minWidthSmall = exports.mediaMaxWidthLarge = exports.mediaMaxWidthMedium = exports.mediaMaxWidthSmall = exports.mediaMaxWidthXtraSmall = exports.wide = exports.huge = exports.large = exports.medium = exports.small = void 0;
var smallPixelCount = 576;
var mediumPixelCount = 768;
var largePixelCount = 992;
var hugePixelCount = 1200;
var widePixelCount = 1366;
// Small devices (landscape phones, 576px and up)
exports.small = "".concat(smallPixelCount, "px");
// Medium devices (tablets, 768px and up)
exports.medium = "".concat(mediumPixelCount, "px");
// Large devices (desktops, 992px and up)
exports.large = "".concat(largePixelCount, "px");
// Extra large devices (large desktops, 1200px and up)ß
exports.huge = "".concat(hugePixelCount, "px");
// Wide screens devices (large desktops, 1366px and up)
exports.wide = "".concat(widePixelCount, "px");
exports.mediaMaxWidthXtraSmall = "@media (max-width: ".concat(smallPixelCount - 1, "px)");
exports.mediaMaxWidthSmall = "@media (max-width: ".concat(mediumPixelCount - 1, "px)");
exports.mediaMaxWidthMedium = "@media (max-width: ".concat(largePixelCount - 1, "px)");
exports.mediaMaxWidthLarge = "@media (max-width: ".concat(hugePixelCount - 1, "px)");
// specifically for in the UserNavMenu
exports.minWidthSmall = "@media (min-width: ".concat(exports.small, ")");
exports.minWidthMedium = "@media (min-width: ".concat(exports.medium, ")");
exports.minWidthLarge = "@media (min-width: ".concat(exports.large, ")");
exports.minWidthHuge = "@media (min-width: ".concat(exports.huge, ")");
//# sourceMappingURL=screenSizes.js.map